var _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRomboGasLp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "81 204 449 447",
    enableBackground: "new 81 204 449 447",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 143,
    display: "inline",
    fill: "#7C2525",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    width: 564,
    height: 521
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    display: "none"
  }, /*#__PURE__*/React.createElement("path", {
    display: "inline",
    fill: "#EA8C8C",
    d: "M498.5,453.1L307,626.2c-7,6.4-17.9,5.8-24.2-1.2L116.1,440.6c-6.4-7-5.8-17.9,1.2-24.2 l191.5-173.2c7-6.4,17.9-5.8,24.2,1.2l166.8,184.4C506.1,435.9,505.6,446.7,498.5,453.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M518.5,444L322.4,640.1c-9,9-23.7,9-32.7,0L93.5,444c-9-9-9-23.7,0-32.7l196.2-196.2c9-9,23.7-9,32.7,0 l196.2,196.2C527.6,420.3,527.6,434.9,518.5,444z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    display: "none"
  }, /*#__PURE__*/React.createElement("image", {
    display: "inline",
    overflow: "visible",
    width: 512,
    height: 512,
    xlinkHref: "../../../Desktop/Desktop/LogoGasLpRombo.png",
    transform: "matrix(0.7793 0 0 0.6719 101 224)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M224.8,421.1c6.6,0,11.1,4.3,11.1,10.9c0,6.5-4.7,10.8-11.6,10.8h-5.2v9h-7.8v-30.8H224.8z M219.1,437 h3.5c3.3,0,5.3-1.7,5.3-4.9c0-3.2-1.9-4.9-5.2-4.9h-3.6L219.1,437L219.1,437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M260.2,444.9c-0.8,4.6-5.2,7.5-11.3,7.5c-7.6,0-11.9-4.5-11.9-12.3c0-7.8,4.5-12.6,11.8-12.6 c7.3,0,11.6,4.4,11.6,12v2.1h-16v0.4c0.1,3.1,1.8,5,4.7,5c2.2,0,3.7-0.8,4.2-2.2L260.2,444.9L260.2,444.9z M244.4,437.4h8.6 c-0.1-2.8-1.7-4.4-4.2-4.4C246.3,433,244.6,434.7,244.4,437.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M272.2,422.8v5.7h4.8v5.6h-4.8v9.6c0,1.8,0.9,2.7,2.9,2.7c0.9,0,1.3,0,1.9-0.1v5.4 c-0.8,0.2-2.2,0.3-3.6,0.3c-6.2,0-8.7-1.9-8.7-6.5v-11.3H261v-5.6h3.7v-5.7H272.2L272.2,422.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M279.8,428.2h7.3v3.9h0.4c0.6-2.4,2.9-4.3,5.8-4.3c0.9,0,2.1,0.1,2.7,0.4v6.4c-0.6-0.2-2.2-0.4-3.2-0.4 c-3.3,0-5.5,1.9-5.5,5.2v12.6h-7.5V428.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M296,440c0-7.7,4.6-12.4,12.1-12.4c7.5,0,12.1,4.7,12.1,12.4c0,7.8-4.5,12.4-12.1,12.4 C300.5,452.4,296,447.8,296,440z M312.5,440c0-4.1-1.6-6.7-4.3-6.7s-4.3,2.5-4.3,6.7c0,4.2,1.6,6.7,4.3,6.7 S312.5,444.2,312.5,440z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M322.7,428.2h7.3v3.9h0.4c0.9-2.8,3.4-4.5,6.5-4.5c3.4,0,5.7,1.6,6.6,4.5h0.4c1-2.7,3.8-4.5,7.1-4.5 c4.7,0,7.7,3.2,7.7,8.1v16.2h-7.5v-14.3c0-2.6-1.2-3.8-3.4-3.8c-2.2,0-3.5,1.6-3.5,3.9v14.2h-7.2v-14.4c0-2.4-1.2-3.7-3.4-3.7 c-2.1,0-3.5,1.6-3.5,4v14.1h-7.5L322.7,428.2L322.7,428.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M361.1,445.1c0-4.3,3.4-6.8,9.5-7.2l5.2-0.3v-1.9c0-1.6-1.2-2.6-3.3-2.6c-2,0-3.3,0.7-3.8,1.9H362 c0.3-4.6,4.5-7.5,11-7.5c6.5,0,10.3,3,10.3,8.1v16.2h-7.3v-2.9h-0.4c-1.1,2-3.7,3.3-6.7,3.3C364.3,452.3,361.1,449.4,361.1,445.1 z M375.8,443.4v-1.6l-4,0.3c-2.2,0.2-3.4,1-3.4,2.5c0,1.5,1.3,2.5,3.2,2.5C374,447,375.8,445.4,375.8,443.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M386.8,428.2h7.3v3.9h0.4c0.6-2.4,2.9-4.3,5.8-4.3c0.9,0,2.1,0.1,2.7,0.4v6.4c-0.6-0.2-2.2-0.4-3.2-0.4 c-3.3,0-5.5,1.9-5.5,5.2v12.6h-7.5L386.8,428.2L386.8,428.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M269.1,502.6l-4.9,35.1c-7.5,3.3-17.9,5.3-27.2,5.3c-22.2,0-34.7-11.5-34.7-31.7 c0-24.8,18.7-41.5,46.3-41.5c9.1,0,16.6,1.8,21.9,3.3l-6.2,19.4c-3.8-1.2-8.7-2.5-14.7-2.5c-15.7,0-21,8.7-21,18.3 c0,10.6,6.4,14.5,12.7,14.5c1,0,1.8-0.1,2.5-0.2l2.8-20L269.1,502.6L269.1,502.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M343.7,541.7h-25.9l-1.4-11.8h-19.8l-4.6,11.8h-26l33.3-70.5h30.8L343.7,541.7z M303.2,513.4h11.3 l-2.6-21.7L303.2,513.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M406.4,516.8c0,17-13.3,26.3-34.1,26.3c-10,0-19.1-2.2-26-5.3l6.8-19.6c4.8,2.7,11.7,5.7,20.4,5.7 c5.8,0,6.8-1.4,6.8-2.4c0-5.8-27.9-0.1-27.9-24.1c0-16.1,12.6-27.5,33-27.5c7.8,0,17.1,1.7,24.4,4.1l-6.8,19.5 c-4.1-2.1-11.6-4.2-18.8-4.2c-3.6,0-6.4,0.5-6.4,2.4C377.8,497.8,406.4,491.9,406.4,516.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0071CE",
    d: "M282.5,281.6c-16,14.8-26,35.9-26,59.4c0,7.2,0.9,14.2,2.7,20.9h0c3.8,14.6,14.2,26.6,27.9,32.5v0 c2.7,1.2,5.7,1.9,8.8,1.9c11.6,0,21-9.4,21-21c0-6.8-3.2-12.8-8.2-16.6C292.7,345.9,275.6,318.2,282.5,281.6L282.5,281.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CE0E2D",
    d: "M324.6,346.3c1.2,0.9,2.3,1.8,3.6,2.6c6.1,5.2,9.9,12.9,9.9,21.5c0,6.6-2.3,12.8-6.2,17.6 c0,0-0.1,0.1-0.2,0.3c8.6-10.3,13.7-23.5,13.7-37.9c0-15.8-6.6-30.6-16.7-41.2c-10.1-10.6-16.7-25.4-16.7-41.3 c0-6.6,1.1-12.9,3.1-18.9v0c0,0-14.4,19.6-14.4,48.3c0,1.2,0,2.5,0.1,3.7C301.8,319.4,310.9,335.6,324.6,346.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00833E",
    d: "M331,289.7c-14.4-18.4-15.9-40.5-16-40.7c-2,5.9-3.1,12.3-3.1,18.9c0,15.8,6.6,30.6,16.7,41.3 c10.1,10.6,16.7,25.4,16.7,41.2c0,14.4-5.2,27.6-13.7,37.9c-0.2,0.4-0.4,1,0.4,1.8c1.1,1.1,2.5-0.4,2.5-0.4 c24.3-17.4,20.8-44,20.8-44C355.4,313.5,331,289.7,331,289.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1D1E1C",
    d: "M305.3,250.2c-7.2,12-11.3,26.1-11.3,41.1c0,24.4,10.8,46.2,27.9,60.9c0,0,10.1,7.2,10.1,20.8 c0,17.6-13,23.2-22,25.1c0,0-0.2,0.1-0.3-0.3c-0.1-0.4,0.2-0.4,0.2-0.4c8.7-3.4,14.8-11.8,14.8-21.7c0-11.9-8.8-18.2-8.8-18.2 c-29.9-24.4-28.4-60.1-28.4-60.1c0-18,6.1-34.6,16.4-47.8c0,0,0.5-0.9,1.4-0.7C306,249.3,305.3,250.2,305.3,250.2z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRomboGasLp);
export default __webpack_public_path__ + "static/media/LogoRomboGasLp.589daddf4ef3f4b00aa13d178f9d0c04.svg";
export { ForwardRef as ReactComponent };